import * as types from "./actionTypes";

const initialState = {
  candidates: [],
  selectedCandidate: {},
  candidateDetails: {},
  candidateDetailLoading: false,
  userSubmissions: [],
  candidateSubmissions: [],
  solrJobs: [],
  solrJobsCount: 0,
  solrJobsLoading: true,
  submissionsTypes: [],
  candidateResumes: [],
  candidateDocuments: [],
  jobDetails: {},
  selectedJob: {},
  selectedJobLoading: false,
  jobDetailsActiveRequestId: 0,
  sendJobToCandidate: [],
  submissionsByJob: [],
  updateSubmissions: [],
  sendProfileToVendor: [],
  isPaneOpen: false,
  isPaneOpenLeft: false,
  rateConfirmation: [],
  selectedSubmission: {},
  interviewSchedule: [],
  updateInterview: [],
  addCandidateResult: {},
  updateCandidate: [],
  statesList: [],
  citiesList: [],
  jobTypesList: [],
  countriesList: [],
  uploadDocument: [],
  openRightPanel: false,
  result: "",
  zipcodesList: [],
  loading: true,
  openAlert: false,
  alertMessage: "",
  alertStatus: "",
  vmailLogin: [],
  vmailsignup: [],
  activeCandLoading: true,
  activeCandidates: [],
  inActiveCandidates: [],
  sourcesList: [],
  sourcesLoading: true,
  selectedSource: {},
  jobInterested: [],
  getInterstedJob: [],
  loginCandidate: {},
  primaryResumeDetails: {},
  primaryResumeDetailsLoading: false,
  recruiterInterestedCandidates: [],
  createNotification: {},
  myRecruiters: [],
  isRecLoading: false,
  addEditRecruiter: {},
  candidateresumeList: [],
  candidateresumeListLoading: false,
  candidateSelectedResume: {},
  latestSolrJobs: null,
  latestSolrJobsCount: null,
  assignCandidatesToRecruiters: [],
  selectedRecruiter: {},
  assignedCandidates: [],
  removeAssignedCandidate: {},
  inactiveRecruiters: {},
  roleBasedJobReports: [],
  getinterestedJobList: [],
  jobsCount: [],
  candidateJobDetails: [],
  interested_jobs_daycount: null,
  jobs_daycount: null,
  jobtype_jobids: null,
  candidate_jobs: [],
  vmail_token: "",
  packageAlertData: null,
};

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.RESET_ACTION:
    case types.USER_LOGOUT:
      return initialState;

    case types.ALERT_SNACK_BAR_ACTION:
      return {
        ...state,
        alertMessage: action.alertMessage,
        alertStatus: action.alertStatus,
        openAlert: true,
      };

    case types.CLOSE_SNACK_BAR_ACTION:
      return {
        ...state,
        openAlert: false,
      };

    case types.RESET_CANDIDATES_ACTION:
      return {
        ...state,
        candidates: [],
        activeCandidates: [],
        inActiveCandidates: [],
        loading: false,
        jobtype_jobids: null,
      };

    case types.GET_CANDIDATES_ACTION:
      return {
        ...state,
        candidates: [...state.candidates, ...action.payload],
        loading: true,
      };

    case types.GET_CANDIDATES_SEARCH_ACTION:
      return {
        ...state,
        candidates: [],
      };

    case types.GET_CANDIDATES_SEARCH_ACTION_SUCCESS:
      return {
        ...state,
        candidates: [...state.candidates, ...action.payload],
      };

    case types.SELECTED_CANDIDATE_ACTION:
      return {
        ...state,
        solrJobs: [],
        solrJobsCount: 0,
        selectedCandidate: action.payload,
      };

    case types.GET_CANDIDATE_DETAIL_LOADING_ACTION:
      return {
        ...state,
        candidateDetailLoading: true,
      };

    case types.GET_CANDIDATE_DETAIL_ACTION:
      return {
        ...state,
        candidateDetails: action.payload,
        candidateDetailLoading: false,
        interested_jobs_daycount: action.interested_jobs_daycount,
        jobs_daycount: action.jobs_daycount,
      };

    case types.GET_CANDIDATE_DETAIL_ACTION_FAIL:
      return {
        ...state,
        candidateDetailLoading: false,
      };

    case types.GET_USER_SUBMISSIONS_ACTION:
      return {
        ...state,
        userSubmissions: action.payload,
      };

    case types.GET_CANDIDATE_SUBMISSIONS_ACTION:
      return {
        ...state,
        candidateSubmissions: action.payload,
      };

    case types.GET_SOLR_JOBS_LOADING_ACTION:
      return {
        ...state,
        solrJobsLoading: true,
      };
    case types.GET_SOLR_JOBS_ACTION:
      return {
        ...state,
        solrJobs: [...state.solrJobs, ...action.payload?.solrJobs],
        solrJobsCount: action.payload?.solrJobsCount,
        solrJobsLoading: false,
      };
    case types.GET_SOLR_JOBS_ACTION_FAIL:
      return {
        ...state,
        solrJobsLoading: false,
      };
    case types.GET_LATEST_SOLR_JOBS_ACTION:
      return {
        ...state,
        latestSolrJobs: action.payload?.latestSolrJobs,
        latestSolrJobsCount: action.payload?.latestSolrJobsCount,
      };

    case types.GET_SUBMISSIONS_TYPES_ACTION:
      return {
        ...state,
        submissionsTypes: action.payload,
      };
    case types.GET_CANDIDATE_RESUME_ACTION:
      return {
        ...state,
        candidateResumes: action.payload,
      };
    case types.GET_CANDIDATE_DOCUMENTS_ACTION:
      return {
        ...state,
        candidateDocuments: action.payload,
      };
    case types.GET_JOB_DETAILS_REQUEST:
      return {
        ...state,
        selectedJobLoading: true,
        jobDetailsActiveRequestId: action.meta?.requestId || 0,
      };
    case types.GET_JOB_DETAILS_ACTION: {
      const incomingId = action.payload?.id;
      const currentId = state.selectedJob?.id;
      const shouldMergeSelectedJob =
        incomingId != null &&
        currentId != null &&
        String(incomingId) === String(currentId);

      return {
        ...state,
        jobDetails: action.payload,
        ...(shouldMergeSelectedJob
          ? {
              selectedJob: {
                ...(state.selectedJob || {}),
                ...(action.payload || {}),
              },
            }
          : {}),
        selectedJobLoading: false,
      };
    }
    case types.GET_JOB_DETAILS_ACTION_FAIL:
      return {
        ...state,
        selectedJobLoading: false,
      };
    case types.OPEN_RIGHT_PANEL_ACTION:
      return {
        ...state,
        openRightPanel: action.payload,
      };

    case types.SELECTED_JOB_ACTION: {
      const nextJob = action.payload;
      if (!nextJob?.id) {
        return {
          ...state,
          selectedJob: nextJob,
          selectedJobLoading: false,
        };
      }

      const isNewSelection =
        String(nextJob.id) !== String(state.selectedJob?.id);

      return {
        ...state,
        selectedJob: nextJob,
        selectedJobLoading: isNewSelection ? true : state.selectedJobLoading,
      };
    }

    case types.SEND_JOB_TO_CANDIDATE_ACTION:
      return {
        ...state,
        sendJobToCandidate: action.payload,
      };
    case types.GET_SUBMISSIONS_ACTION:
      return {
        ...state,
        submissionsByJob: action.payload,
      };
    case types.UPDATE_SUBMISSIONS_ACTION:
      return {
        ...state,
        updateSubmissions: action.payload,
      };
    case types.SEND_PROFILE_TO_VENDOR:
      return {
        ...state,
        sendProfileToVendor: action.payload,
      };
    case types.RATE_CONFIRMATION_ACTION:
      return {
        ...state,
        rateConfirmation: action.payload,
      };
    case types.SELECTED_SUBMISSION_ACTION:
      return {
        ...state,
        selectedSubmission: action.payload,
        openRightPanel: false,
      };
    case types.INTERVIEW_SCHEDULE_ACTION:
      return {
        ...state,
        interviewSchedule: action.payload,
      };
    case types.UPDATE_INTERVIEW_SCHEDULE_ACTION:
      return {
        ...state,
        updateInterview: action.payload,
      };
    case types.ADD_CANDIDATE_ACTION:
      return {
        ...state,
        addCandidateResult: action.payload,
        result: action.result,
      };
    case types.UPDATE_CANDIDATE_ACTION:
      return {
        ...state,
        updateCandidate: action.payload,
      };
    case types.GET_STATES_ACTION:
      return {
        ...state,
        statesList: action.payload,
      };
    case types.GET_CITIES_ACTION:
      return {
        ...state,
        citiesList: action.payload,
      };
    case types.GET_JOBTYPES_ACTION:
      return {
        ...state,
        jobTypesList: action.payload,
      };
    case types.GET_COUNTRIES_ACTION:
      return {
        ...state,
        countriesList: action.payload,
      };
    case types.UPLOAD_DOCUMENTS_ACTION:
      return {
        ...state,
        uploadDocument: action.payload,
      };
    case types.GET_ZIPCODES_ACTION:
      return {
        ...state,
        zipcodesList: action.payload,
      };
    case types.VMAIL_SIGNIN_ACTION:
      return {
        ...state,
        vmailLogin: action.payload,
      };
    case types.VMAIL_SIGNUP_ACTION:
      return {
        ...state,
        vmailsignup: action.payload,
      };
    case types.GET_ACTIVE_CANDIDATES_LOADING_ACTION:
      return {
        ...state,
        activeCandLoading: true
      }
    case types.GET_ACTIVE_CANDIDATES_ACTION:
      return {
        ...state,
        // activeCandidates: action.payload,
        activeCandidates: [...state.activeCandidates, ...action.payload],
        loading: true,
        activeCandLoading: false
      };
    case types.GET_ACTIVE_CANDIDATES_ACTION_FAIL:
      return {
        ...state,
        activeCandLoading: false
      }
    case types.GET_INACTIVE_CANDIDATES_ACTION:
      return {
        ...state,
        inActiveCandidates: action.payload,

        loading: true,
      };
    case types.GET_SOURCES_LOADING_ACTION:
      return {
        ...state,
        sourcesLoading: true,
      };
    case types.GET_SOURCES_ACTION:
      return {
        ...state,
        sourcesList: action.payload,
        sourcesLoading: false,
      };
    case types.GET_SOURCES_ACTION_FAIL:
      return {
        ...state,
        sourcesLoading: false,
      };
    case types.SELECTED_SOURCE_ACTION:
      return {
        ...state,
        selectedSource: action.payload,
      };
    case types.GET_INTERESTED_JOB_ACTION:
      return {
        ...state,
        getInterstedJob: action.payload,
      };
    case types.CANDIDATE_LOGIN_ACTION:
      return {
        ...state,
        loginCandidate: action.payload,
      };
    case types.GET_PRIMARY_RESUME_DETAILS_LOADING_ACTION:
      return {
        ...state,
        primaryResumeDetailsLoading: true,
      };
    case types.GET_PRIMARY_RESUME_DETAILS_ACTION:
      return {
        ...state,
        primaryResumeDetails: action.payload,
        primaryResumeDetailsLoading: false,
      };
    case types.GET_PRIMARY_RESUME_DETAILS_ACTION_FAIL:
      return {
        ...state,
        primaryResumeDetailsLoading: false,
      };

    case types.GET_RECRUITER_INTERESTED_CANDIDATES_ACTION:
      return {
        ...state,
        recruiterInterestedCandidates: action.payload,
      };
    case types.CREATE_NOTIFICATION_ACTION:
      return {
        ...state,
        createNotification: action.payload,
      };

    case types.GET_MY_ACTIVE_RECRUITERS_LOADING:
      return {
        ...state,
        isRecLoading: true,
      };

    case types.GET_MY_ACTIVE_RECRUITERS_ACTION:
      return {
        ...state,
        isRecLoading: false,
        myRecruiters: action.payload,
      };

    case types.GET_MY_ACTIVE_RECRUITERS_ACTION_FAIL:
      return {
        ...state,
        isRecLoading: false,
      };

    case types.ADD_OR_EDIT_RECRUITER_ACTION:
      return {
        ...state,
        addEditRecruiter: action.payload,
      };

    case types.GET_CANDIDATES_RESUMES_LIST_ACTION:
      return {
        ...state,
        candidateresumeList: action.payload,
      };

    case types.GET_CANDIDATES_RESUMES_LIST_ACTION_TEMP_LOADING_ACTION:
      return {
        ...state,
        candidateresumeListLoading: true,
      };

    case types.GET_CANDIDATES_RESUMES_LIST_ACTION_TEMP:
      return {
        ...state,
        candidateresumeList: action.payload,
        candidateresumeListLoading: false,
      };

    case types.GET_CANDIDATES_RESUMES_LIST_ACTION_FAIL:
      return {
        ...state,
        candidateresumeListLoading: false,
      };

    case types.CANDIDATE_SELECTED_RESUME_ACTION:
      return {
        ...state,
        candidateSelectedResume: action.payload,
      };

    case types.SELECTED_RECRUITER_ACTION:
      return {
        ...state,
        selectedRecruiter: action.payload,
      };

    case types.GET_ASSIGNED_CANDIDATES_ACTION:
      return {
        ...state,
        assignedCandidates: action.payload,
      };

    case types.REMOVE_ASSIGNED_CANDIDATES_ACTION:
      return {
        ...state,
        removeAssignedCandidate: action.payload,
      };
    case types.GET_INACTIVE_RECRUITERS_ACTION:
      return {
        ...state,
        inactiveRecruiters: action.payload,
      };

    case types.CANDIDATE_ROLE_BASED_JOB_REPORTS:
      return {
        ...state,
        roleBasedJobReports: action.payload,
      };

    case types.GET_INTERESTED_JOB_LIST_ACTION:
      return {
        ...state,
        getinterestedJobList: action.payload,
      };

    case types.GET_JOBS_COUNT_ACTION:
      return {
        ...state,
        jobsCount: action.payload,
      };

    case types.GET_CANDIDATE_JOBDETAILS_ACTION:
      return {
        ...state,
        candidateJobDetails: action.payload,
      };
    case types.GET_JOBTYPE_FILTERED_IDS_ACTION:
      return {
        ...state,
        jobtype_jobids: action.payload,
      };
    case types.REMOVE_JOBTYPE_FILTER_ACTION:
      return {
        ...state,
        jobtype_jobids: null,
      };
    case types.GET_JOBS_FROM_DB_ACTION:
      return {
        ...state,
        candidate_jobs: action.payload,
      };

    case types.GET_JOBS_FROM_DB_FAIL_ACTION:
      return {
        ...state,
        candidate_jobs: null,
      };

    case types.RECRUITERS_ACTIVITY_ACTION:
      return {
        ...state,
        myRecruiters: state.myRecruiters.map((recruiter) => {
          const activity = action.payload.find(
            (activity) =>
              activity.email === recruiter.recruiter_email &&
              parseInt(activity.id) === parseInt(recruiter.recruiter_id)
          );
          if (activity) {
            return { ...recruiter, activity };
          }
          return recruiter;
        }),
      };

    case types.VMAIL_TOKEN_ACTION:
      //console.log("Setting vmail_token:", action.payload, typeof action.payload);
      return {
        ...state,
        vmail_token: action.payload,
      };

    case types.GET_COMPANY_PACKAGE_DATA_ACTION:
      return {
        ...state,
        packageAlertData: action.payload,
      };

    case types.UPDATE_PACKAGE_ALERT_LOG_ACTION:
      return {
        ...state,
        packageAlertData: null,
      };

    default:
      return state;
  }
}
